import React from "react";

// Player initials avatar (design §4: circle, tint #E8F1FF / #1B6FE0). Derives up
// to two initials from the snapshotted name; falls back to a neutral dot.
const initialsOf = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ScoutAvatar = ({ name, size = 40 }) => (
  <span
    className="inline-flex items-center justify-center rounded-full font-semibold flex-shrink-0"
    style={{
      width: size,
      height: size,
      backgroundColor: "#E8F1FF",
      color: "#1B6FE0",
      fontSize: Math.round(size * 0.36),
    }}
    aria-hidden="true"
  >
    {initialsOf(name)}
  </span>
);

export default ScoutAvatar;
